import { SimpleSocialLanding } from "@/components/SimpleSocialLanding";
import { BRAND_PERSON_NAME } from "@/lib/brandConfig";

const Belleza = () => (
  <SimpleSocialLanding
    seoPageKey="belleza"
    i18nPrefix="simplePages.belleza"
    imageAlt={`${BRAND_PERSON_NAME} - Beauty and beauty tips content creator portrait photo`}
  />
);

export default Belleza;
